import {
    AUTH_DIALOG
} from '../types'

const initialState = {
    option: null,
    error: null,
    loanding: false
}

const generalReducer = (state = initialState, { type, payload }) => {
    switch(type) {
        case AUTH_DIALOG:
            return {
                ...state,
                option: payload
            }
        
        default:
            return state;
    }
}

export default generalReducer;